import { ImageList, ImageListItem, Skeleton } from "@mui/material";
import styled from "styled-components";
import { sizes, utils, weights } from "./variables";

export const Box = styled.div`
  padding: ${({ p }) => p || "0"};
  margin: ${({ m }) => m || "0"};
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || "transparent "};
`;

export const Flex = styled(Box)`
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  background: ${({ background }) => background || ""};
  background-size: contain;
  background-repeat: no-repeat;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || "transparent "};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || "row"};
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  gap: ${({ gap }) => gap || "0rem"};
  box-shadow: ${({ boxShadow }) => boxShadow};
  border-radius: ${({ borderRadius }) => borderRadius};
`;

export const Label = styled.span`
  line-height: ${({ lineHeight }) => lineHeight || '1.4'};
  font-family: ${({ fontFamily }) => fontFamily || "Inter"};
  font-size: ${({ fontSize }) => fontSize || sizes.xs};
  font-weight: ${({ fontWeight }) => fontWeight || weights.regular};
  text-align: ${({ textAlign }) => textAlign || "left"};
  color: ${({ color }) => color || "black"};

  &:hover {
    color: ${({ hoverColor, color }) => hoverColor || color};
  }

  span.highlight {
    background: -webkit-linear-gradient(#FE006E , #245EF3);
    background: -o-linear-gradient(#FE006E, #245EF3);
    background: -moz-linear-gradient(#FE006E, #245EF3);
    background: linear-gradient(to #FE006E, #245EF3); 
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .link {
    font-weight: ${weights.black};
    cursor: pointer;
    text-decoration: underline;
    font-weight: ${weights.black};
    background: -webkit-linear-gradient(#FE006E , #245EF3);
    background: -o-linear-gradient(#FE006E, #245EF3);
    background: -moz-linear-gradient(#FE006E, #245EF3);
    background: linear-gradient(to #FE006E, #245EF3); 
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const GalleryContainer = styled.div`
  width: 95vw;
  padding: ${sizes.sm} !important;
  .grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    width: 100%;
  }
  .grid-column {
    background-clip: padding-box;
  }
`;

export const Canvas = styled(ImageListItem)`
  cursor: pointer;
  img {
    border-radius: ${sizes.xs2};
    &:hover {
      transform: scale(1.01);
    }
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
  }
`;
export const SkeletonContainer = styled(Skeleton)`
  margin-bottom: ${sizes.xs};
  border-radius: ${sizes.xs};
`;

export const LoadingContainer = styled(ImageList)`
  width: calc(${utils.width.fullVW} - ${sizes.lg});
  padding: ${sizes.xs};
`;

export const BorderTest = styled.div`
  height: 240px;
  width: 240px;
`;
